import React from 'react';
import SmsTracker from '../components/SmsTracker';

const SmsTrackerPage = () => {
  return (
    <div className="sms-tracker-page">
      <SmsTracker />
    </div>
  );
};

export default SmsTrackerPage;
